import * as Sentry from '@sentry/browser'

// Actions
import {
  RESET_REFI_REQUEST,
  SEND_REFI_REQUEST,
  SEND_REFI_SUCCESS,
  SEND_REFI_FAILURE,
  SET_REFI_MONTHS_IN_HOME
} from './actionTypes'
import { trackHomeActivityMikasa } from 'src/actions/home'

// Constants
import { SYSTEM_REQUEST } from 'src/constants/messages'
import { REFINANCING_TOPIC_KEY } from 'src/constants/topicKeys'
import {
  REFI_DETAILS_EVENT_SUBMITTED_KEY,
  REFI_DETAILS_VIEW_EVENT
} from 'src/constants/refinance'

// Requests
import { createHomeownerMessage } from 'src/api/mikasa/requests'

// Selectors
import { selectHomeId } from 'src/store/selectors/home/refinance'
import { selectClientId } from 'src/store/selectors/client'

// Helpers
import { getSafeSessionStorage } from 'src/helpers/browser'

export const sendRefiRequestForClient = label => async (dispatch, getState) => {
  const state = getState()
  const homeId = selectHomeId(state)
  const clientId = selectClientId(state)

  let message = SYSTEM_REQUEST.refiMessage.defaultMessage
  if (label) {
    message = SYSTEM_REQUEST.labeledRefiMessage.defaultMessage.replace(
      '{label}',
      label.toString()
    )
  }

  dispatch({ type: SEND_REFI_REQUEST })

  try {
    const options = {
      topic: SYSTEM_REQUEST.refiTopic.defaultMessage,
      topicKey: REFINANCING_TOPIC_KEY,
      message,
      clientId
    }

    await createHomeownerMessage(homeId, options)

    dispatch({ type: SEND_REFI_SUCCESS })
  } catch (error) {
    Sentry.captureException(error)

    dispatch({ type: SEND_REFI_FAILURE })
  }
}

export const resetRefiRequestStatus = () => dispatch =>
  dispatch({
    type: RESET_REFI_REQUEST
  })

export const setYearsInHome = years => dispatch => {
  dispatch({
    type: SET_REFI_MONTHS_IN_HOME,
    years
  })
}

const sessionStorage = getSafeSessionStorage()

const setRefiDetailsEventSubmitted = () =>
  sessionStorage.setItem(REFI_DETAILS_EVENT_SUBMITTED_KEY, true)

const getRefiDetailsEventSubmitted = () =>
  sessionStorage.getItem(REFI_DETAILS_EVENT_SUBMITTED_KEY)

export const trackRefiDetailsViewEvent = opt => (dispatch, getState) => {
  if (!getRefiDetailsEventSubmitted()) {
    dispatch(
      trackHomeActivityMikasa({
        eventName: REFI_DETAILS_VIEW_EVENT,
        eventProperties: {
          activity_source: 'user'
        }
      })
    )
    setRefiDetailsEventSubmitted()
  }
}
